export default "__VITE_ASSET__Ap1cPVql__"